import * as common from '../common';

const { http } = common.utils;

export const fetchUser = async () => http.get(`${common.constants.ACCOUNT_SERVICE_URL}/me`);
